import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(
    public http: HttpClient
  ) { }


  enviar(mensaje: string, asunto: string = 'Contacto Pagina Web - Servios') {

    // tslint:disable-next-line: max-line-length
    const url = `http://www.fundacionparaguaya.org.py/fupapp-rest-trans/public/mail/send-externo?remitente=amplificapy@gmail.com&clave=xwvrmtauxdxqpahr&destinatario=jaimeferreira11@gmail.com&cc=null&asunto=${asunto}&cuerpo=${mensaje}`;

    const body = new HttpParams()
      .set('remitente', 'amplificapy@gmail.com')
      .set('clave', 'xwvrmtauxdxqpahr')
      .set('destinatario', 'serviosventas@gmail.com')
      .set('cc', 'null')
      .set('asunto', asunto)
      .set('cuerpo', mensaje);

    return this.http.post(url, {}, { responseType: 'text' });

  }
}
